import { Model } from '@/models'
import { ConsultantNotificationEmailAddress } from '@/models/consultantNotificationEmailAddress'

export class ConsultantNotificationSettings extends Model {
    /**
     * Create a ConsultantNotificationSettings model wrapper.
     * @param {Object} data - Object holding the field values.
     */
    constructor (data) {
        super()
        Model.initializeFields(this, [
            'notificationEmailAddresses',
        ], data)
    }

    addConsultantNotificationEmailAddress (variables) {
        return ConsultantNotificationEmailAddress.create(variables).then(consultantNotificationEmailAddress => {
            this.notificationEmailAddresses.push(consultantNotificationEmailAddress)
            return consultantNotificationEmailAddress
        })
    }
}
